<template>
  <div class="text-center d-flex flex-column align-items-center" id="Benvenuto">
    <p>
      Benvenuto nel
      <span class="Bolder">sistema di prenotazione pasti</span> dell'azienda
      Ospedaliero-Universitaria di Bologna IRCCS
    </p>
    <BenvenutoImg />
    <p>
      Gentile utente, <span class="Bolder">la linea nutrizionale</span> e il
      relativo menù le sono stati
      <span class="Bolder">
        assegnati dal medico di reparto e non possono essere modificati dalla
        cucina </span
      >. Per chiarimenti può chiedere al suo medico di riferimento durante il
      suo ricovero.
    </p>
    <p>
      <span class="Bolder">
        La personalizzazione dei piatti è possibile fino alle ore 23:30 del
        giorno antecedente le richieste</span
      >. In caso di difficoltà nel collegamento o nella scelta dei piatti oppure
      nell'utilizzo del servizio è possibile avere supporto contattando dal
      lunedì alla domenica
      <span class="Bolder">il numero 051.214.2295/2219</span>
      <br />dalle ore 7:00 alle 19:00
    </p>
    <button
      class="btn btn-primary d-flex text-center align-items-center"
      @click="goToRichieste"
    >
      Prosegui
      <div class="icons ml-1">
        <font-awesome-icon icon="arrow-right" class="primary-icon" />
      </div>
    </button>
  </div>
</template>

<script>
import { nameRoutes } from "../../libs/router/nameRoutes";
import LABEL from "../../libs/utils/label";

import { BenvenutoImg } from "../../components/icons";

export default {
  name: "Benvenuto",
  components: {
    BenvenutoImg,
  },
  data() {
    return {
      LABEL,
      nameRoutes,
    };
  },
  methods: {
    goToRichieste: function () {
      this.$router.push({ name: nameRoutes.RICHIESTE });
    },
  },
};
</script>

<style lang="scss" scoped></style>
